export default {
  meta: {
    state: 200,
    msg: "操作成功",
  },
  data: [
    {
      path: "/",
      // name: "admin",
      component: () => import("@/Layout/Index.vue"),
      children: [
        // {
        //   path: "/", // 首页
        //   alias: "/",
        //   component: () => import("@/views/main/Index.vue"),
        //   // name: "home",
        //   meta: { name: "首页", icon: "icon-fangzi" },
        // },
        {
          path: "/policyInfo",
          alias: "/",
          component: () => import("@/views/policyInfo/Index.vue"),
          // name: "home",
          meta: { name: "首页", icon: "icon-zhengce" },
        },
        {
          path: "/powerinformation",
          component: () => import("@/views/powerInformation/Index.vue"),
          // name: "powerinformation",
          meta: { name: "用电信息", icon: "icon-leidian" },
          children: [
            {
              path: "zduser",
              alias: "/powerinformation",
              component: () =>
                import("@/views/powerInformation/user/Index.vue"),
            },
            {
              path: "zhuanqueryhistory",
              component: () =>
                import(
                  "@/views/powerInformation/components/zhuanQueryHistory/Index.vue"
                ),
            },
          ],
        },
        {
          path: "/electricitysettlement",
          component: () => import("@/views/electricitySettlement/Index.vue"),
          // name: "electricitysettlement",
          meta: { name: "结算信息", icon: "icon-qiandai" },
          children: [
            {
              path: "user",
              alias: "/electricitysettlement",
              component: () =>
                import("@/views/electricitySettlement/user/Index.vue"),
            },
            {
              path: "userSettle",
              component: () =>
                import("@/views/electricitySettlement/user/UserSettle.vue"),
            },
          ],
        },
        {
          path: "/application",
          meta: { name: "应用", icon: "icon-qiandai" },
          component: () => import("@/views/application/Index.vue"),
          children: [
            {
              path: "/demandResponse",
              component: () =>
                import("@/views/application/demandResponse/Index.vue"),
              meta: { name: "需求响应", icon: "icon-qiandai" },
              children: [
                {
                  path: "/userDemand",
                  alias: "/demandResponse",
                  component: () =>
                    import("@/views/application/demandResponse/user/index.vue"),
                },
              ],
            },
            {
              path: "/businessExpansion",
              // redirect:'/user',
              component: () =>
                import("@/views/application/businessExpansion/Index.vue"),
              meta: { name: "业扩报装", icon: "icon-qiandai" },
              children: [
                {
                  path: "/user",
                  alias: "/businessExpansion",
                  component: () =>
                    import(
                      "@/views/application/businessExpansion/user/index.vue"
                    ),
                },
              ],
            },
            {
              path: "/energymanagement",
              component: () => import("@/views/energyManagement/Index.vue"),
              // name: "energymanagement",
              meta: { name: "综合管理", icon: "icon-ziliaoku-shuji" },
              children: [
                {
                  path: "history",
                  alias: "/energymanagement",
                  component: () =>
                    import("@/views/energyManagement/user/Index.vue"),
                },
              ],
            },
          ],
        },
        {
          path: "/complaintSuggestion",
          component: () => import("@/views/complaintSuggestion/Index.vue"),
          meta: { name: "投诉与建议", icon: "icon-qiandai" },
          children: [
            {
              path: "/complain",
              alias: "/complaintSuggestion",
              component: () =>
                import("@/views/complaintSuggestion/complain/index.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "*",
      component: () => import("@/views/404.vue"),
    },
  ],
};
